import { Component, inject, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DashboardSearchService } from '../services/dashboard-search.service';
import { AuthenticationService } from '@core/services/auth.service';
@Component({
  selector: 'app-dashboard-header',
  standalone: true,
  templateUrl: './dashboard-header.component.html',
  imports: [RouterLink, FormsModule]
})
export class DashboardHeaderComponent {
  private dashboardSearchService = inject(DashboardSearchService);
  private authService = inject(AuthenticationService)
  searchEnabled = computed(() => this.dashboardSearchService.searchEnabled());

  onSearchChange(event: any): void {
    const searchTerm = (event?.target as HTMLInputElement)?.value;
    this.dashboardSearchService.searchTerm.set(searchTerm);
  }

  logout(){
    this.authService.logout();
  }
}
